import { useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Search as SearchIcon } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export default function Search() {
    const [q, setQ] = useState("");
    const [res, setRes] = useState({ students: [], users: [] });

    const run = async () => {
        if (!q.trim()) return;
        const { data } = await api.get("/admin/search", { params: { q } });
        setRes(data);
    };

    return (
        <div className="space-y-5">
            <div><h1 className="text-2xl font-bold text-[#0F172A]">البحث الشامل</h1><p className="text-sm text-slate-500 mt-1">ابحثي في الطالبات، أولياء الأمور، والمدربات</p></div>
            <div className="flex gap-2 max-w-2xl">
                <div className="relative flex-1"><SearchIcon className="w-4 h-4 text-slate-400 absolute right-3 top-1/2 -translate-y-1/2" /><Input data-testid="global-search-input" value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && run()} placeholder="اسم / رقم هوية / اسم مستخدم / صف..." className="pr-10 h-11" /></div>
                <Button onClick={run} className="bg-[#1B2A4E] hover:bg-[#0F172A] h-11 px-6" data-testid="btn-search">بحث</Button>
            </div>

            {(res.students.length > 0 || res.users.length > 0) && (
                <div className="grid md:grid-cols-2 gap-4">
                    <div className="bg-white border border-slate-200 rounded-xl">
                        <div className="px-4 py-3 border-b border-slate-100 font-semibold text-sm text-[#0F172A]">الطالبات ({res.students.length})</div>
                        <div className="divide-y divide-slate-100">
                            {res.students.map((s) => (
                                <div key={s.id} className="px-4 py-3 flex items-center justify-between text-sm">
                                    <div><div className="font-medium">{s.full_name}</div><div className="text-xs text-slate-500 font-mono-num" dir="ltr">{s.national_id}</div></div>
                                    <div className="text-xs text-slate-500">{s.grade} {s.section}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="bg-white border border-slate-200 rounded-xl">
                        <div className="px-4 py-3 border-b border-slate-100 font-semibold text-sm text-[#0F172A]">الحسابات ({res.users.length})</div>
                        <div className="divide-y divide-slate-100">
                            {res.users.map((u) => (
                                <div key={u.id} className="px-4 py-3 flex items-center justify-between text-sm">
                                    <div><div className="font-medium">{u.full_name}</div><div className="text-xs text-slate-500 font-mono-num" dir="ltr">{u.username}</div></div>
                                    <Badge variant="outline" className="text-[10px]">{u.role}</Badge>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
